// @flow

import { jitsiLocalStorage } from '@jitsi/js-utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { IconEye, IconEyeOff } from '../../../base/icons';
import { OverflowMenuItem } from '../../../base/toolbox/components';
import { setChatNotificationsHidden } from '../../../chat/actions.any';

/**
 * Quick in-meeting toggles for the "hide chat notifications" preference
 * (also available in Settings).
 *
 * @returns {React$Element<any>}
 */
export default function MeetingPreferencesItems() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const chatHidden = useSelector(state => Boolean(state['features/chat']?.areChatNotificationsHidden));

    const onToggleChat = () => {
        dispatch(setChatNotificationsHidden(!chatHidden));
        if (chatHidden) {
            jitsiLocalStorage.removeItem('hide_chat_notifications');
        } else {
            jitsiLocalStorage.setItem('hide_chat_notifications', 'true');
        }
    };

    const chatText = chatHidden
        ? t('chat.showChatNotifications') : t('chat.hideChatNotifications');

    return (
        <div
            className = 'col-m-4'
            key = 'chat-notifications'>
            <OverflowMenuItem
                accessibilityLabel = { chatText }
                icon = { chatHidden ? IconEye : IconEyeOff }
                onClick = { onToggleChat }
                text = { chatText } />
        </div>
    );
}
